import Vue from "vue";
import Vuex from "vuex";
import profile from "./modules/profile";
import order from "./modules/order";
import user from "./modules/user";
import adminUser from "./modules/adminUser";
import cryptoCurrency from "./modules/cryptoCurrency";
import appApi from "./modules/appApi";
import wallet from "./modules/wallet";
import dashboard from "./modules/dashboard";
import withdrawal from "./modules/withdrawal";
import timezone from "./modules/timezone";
import appConfig from "./modules/appConfig";
import directWallet from "./modules/directWallet.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    appConfig,
    profile,
    order,
    user,
    adminUser,
    cryptoCurrency,
    appApi,
    wallet,
    dashboard,
    withdrawal,
    timezone,
    directWallet
  },
  state: {},
  mutations: {},
  actions: {}
});

export default store;
